import { useEffect } from 'react';
import shallow from 'zustand/shallow';
import { Recent } from '../context/contexts/recentlyViewsContext';
import { useStore } from '../context/store';

export const useRecentlyViewedContext = ({ text, url, description, viewName, enabled = true }: Partial<Recent> & { enabled?: boolean }) => {
    const pushRecentHistory = useStore(store => store.pushRecentHistory, shallow);
    useEffect(() => {
        if (text && url && enabled) {
            pushRecentHistory({
                text,
                url,
                description,
                viewName,
            });
        }
    }, [text, url, description, pushRecentHistory, viewName, enabled]);
};
